<template>
    <b-modal
      id="modal-confirm-check-out"
      v-model="dialog"
      centered
      hide-header
    >
      <b-card-header class="header-banner">
       
        <div class="d-flex justify-content-between align-items-center block-header">
          <h5 class="mb-0 header-banner-title">
            Check-out
          </h5>
          <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer"
            @click="close"
          />
        </div>
      </b-card-header>
      <b-card-body>
        <b-overlay
          :show="isLoading"
          :opacity="0.3"
          rounded="sm"
        >
        <b-row>
          <b-col cols="12" class="confirm-span">
            <span class="confirm-quick-action-span">{{ $t('golf_booking_confirm_quick_checkout_print_type') }}</span>
          </b-col>
          
        </b-row>
        <b-row>
         
          <b-col>
            <v-select 
                    class="truncate-label"
                    v-model="paymentAction"
                    :options="paymentTypeOptions"
                    :clearable="false"
                    :searchable="false"
                    label="title"
                    :reduce="option => option.value"
                  />
          </b-col>
        </b-row>
        </b-overlay>
      </b-card-body>
      <template #modal-footer>
          <div>
            <b-button
              variant="primary"
              @click="confirmDialog"
              :disabled ="isLoading"
              class="mr-2"
            >
              {{ $t('golf_common_confirm') }}
            </b-button>
            <b-button
              
              variant="outline-secondary"
              @click="close"
              :disabled ="isLoading"
            >
              {{ $t('golf_common_cancel') }}
            </b-button>
           
          </div>
  
        </template>
    </b-modal>
  </template>
  
<script>
import { booking } from '@/api/booking'
import { number } from 'echarts/lib/export';

  export default {
    props:{
        listBookingDetailId: {
        type: Array
    },
    BookingDetailPaymentId :{
          type: number
        }
    },

    data() {
      return {
        dialog: false,
        paymentAction : null,
        item: {
          dataConfirm: {
            title: 'abcass',
            content: 'bsaass',
            hideFooter: false,
          },
        },
        isLoading: false,
        listBookingDetailCheckOutRequest : [],
        isShowDetailListInvoice:true,
      }
    },
    watch: {
      dialog(value) {
        if(!value) {
          //this.$emit('cancelDialog', this.item)
        } else {
          this.paymentAction = this.paymentTypeOptions && this.paymentTypeOptions.length > 0 ? this.paymentTypeOptions[2].value : null
        }
      },
      Type(){
        this.paymentAction = this.paymentTypeOptions && this.paymentTypeOptions.length > 0 ? this.paymentTypeOptions[2].value : null
      },
    },
    computed: {
      paymentTypeOptions() {
        return [
          { title: this.$t('golf_booking_checkout_booking_payment_pay'), value: 'pay' },
          { title: this.$t('golf_booking_checkout_booking_payment_has'), value: 'has' },
          { title: this.$t('golf_booking_checkout_booking_payment_all'), value: 'all' }
        ];

    }
  },
  
    methods: {
      open(item) {
        this.dialog = true
        this.item = item
      },
      close() {
        this.cancelDialog()
        this.dialog = false
      },
      async confirmDialog() {
        //this.removeInvoice_and_PaymentDetail_api_DPM09()
        await this.QuickCheckOut_apiICI02()
        this.dialog = false
        
      },
      cancelDialog() {
        this.dialog = false

      },
      showListDetailInvoice(){
      this.isShowDetailListInvoice = ! this.isShowDetailListInvoice
    },
     
    async QuickCheckOut_apiICI02() {
      this.listBookingDetailCheckOutRequest = []
    if (this.paymentAction === 'pay') {
    this.listBookingDetailCheckOutRequest.push(this.BookingDetailPaymentId);
  } else if (this.paymentAction === 'has') {
    this.listBookingDetailCheckOutRequest = [...this.listBookingDetailId];
  } else {
    this.listBookingDetailCheckOutRequest = [...this.listBookingDetailId];
    this.listBookingDetailCheckOutRequest.push(this.BookingDetailPaymentId)
  }
      const body = {
        BookingDetailId: this.listBookingDetailCheckOutRequest,
      }
      await booking.api_ICI02(body).then(res => {
        this.showResToast(res)
        if (res.Status === '200') {
          this.$emit('event')
          this.close();
                
        }
      })
    },

  }
}
  </script>
  <style scoped lang="scss" >
  #modal-confirm-check-out {
    .modal-content {
        width: 600px !important;
    }
    .truncate-label .vs__selected {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%; /* đảm bảo không tràn ra ngoài */
  }
  .truncate-label .vs__search {
  display: none !important;
}
    .card-body {
      margin-bottom: 20px;
      .confirm-span {
      margin-bottom: 15px;
    }
    }
    .block-header {
      .title-modal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
      }
    }
    .color-primary {
      color: #114A9F;
    }
  
    .w-50 {
      width: 65px !important;
    }
  
    .color-warning {
      color: #FF9F43;
    }
    .header-text{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgba(34, 41, 47, 0.05);
        padding-bottom: 0.6rem;
    }
    .header-banner{
        background-color: #e2e9f3;
        color: #114A9F !important;
        .header-banner-title {
            color: #114A9F !important;
        }
    }
    
    
    
  }
  </style>